import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-lead-campaign-dialog',
  templateUrl: './edit-lead-campaign-dialog.component.html',
  styleUrls: ['./lead-campaign.component.css']
})
export class EditLeadCampaignDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditLeadCampaignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', model: this.data.model });
  }

}
